import { api } from '@/lib/api';
import type {
  OpportunityRole,
  CreateRoleDto,
  UpdateRoleDto,
} from '../types/role.types';

const BASE_URL = '/tm/roles';

/**
 * Service pour les rôles sur les opportunités
 */
export const rolesService = {
  /**
   * Récupère les rôles d'une opportunité
   */
  async getByOpportunity(opportunityId: number): Promise<OpportunityRole[]> {
    const response = await api.get<OpportunityRole[]>(
      `${BASE_URL}/opportunity/${opportunityId}`
    );
    return response.data;
  },

  /**
   * Récupère le coordinateur d'une opportunité
   */
  async getCoordinator(opportunityId: number): Promise<OpportunityRole | null> {
    const response = await api.get<OpportunityRole | null>(
      `${BASE_URL}/opportunity/${opportunityId}/coordinator`
    );
    return response.data;
  },

  /**
   * Récupère un rôle par son ID
   */
  async getById(id: number): Promise<OpportunityRole> {
    const response = await api.get<OpportunityRole>(`${BASE_URL}/${id}`);
    return response.data;
  },

  /**
   * Crée une assignation de rôle
   */
  async create(dto: CreateRoleDto): Promise<OpportunityRole> {
    const response = await api.post<OpportunityRole>(BASE_URL, dto);
    return response.data;
  },

  /**
   * Met à jour une assignation de rôle
   */
  async update(id: number, dto: UpdateRoleDto): Promise<OpportunityRole> {
    const response = await api.patch<OpportunityRole>(`${BASE_URL}/${id}`, dto);
    return response.data;
  },

  /**
   * Supprime une assignation de rôle
   */
  async delete(id: number): Promise<void> {
    await api.delete(`${BASE_URL}/${id}`);
  },
};
